module.exports = __webpack_public_path__ + "img/notArrived.106bc6dd.svg";